class NewMobileNavigation {
  constructor(root) {
    this.root = root;
    this.onClick = this.onClick.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);

    this.root.addEventListener('click', this.onClick);
    document.addEventListener('action:hideDrawer', this.onDrawerClose);
  }

  onClick(event) {
    const openTrigger = event.target.closest('[data-mobile-submenu-open]');
    if (openTrigger) {
      event.preventDefault();
      const submenu = openTrigger.nextElementSibling;
      if (!submenu?.matches('[data-mobile-submenu]')) return;

      submenu.classList.add('is-active');
      openTrigger.setAttribute('aria-expanded', 'true');
      return;
    }

    const closeTrigger = event.target.closest('[data-mobile-submenu-close]');
    if (closeTrigger) {
      event.preventDefault();
      const submenu = closeTrigger.closest('[data-mobile-submenu]');
      if (!submenu) return;

      submenu.querySelectorAll('[data-mobile-submenu].is-active').forEach((nestedSubmenu) => {
        nestedSubmenu.classList.remove('is-active');
        nestedSubmenu.previousElementSibling?.setAttribute('aria-expanded', 'false');
      });
      submenu.classList.remove('is-active');
      const openTriggerEl = submenu.previousElementSibling;
      openTriggerEl?.setAttribute('aria-expanded', 'false');
    }
  }

  onDrawerClose(event) {
    if (event.detail?.drawerType !== 'header') return;

    this.root.querySelectorAll('[data-mobile-submenu].is-active').forEach((submenu) => {
      submenu.classList.remove('is-active');
    });

    this.root.querySelectorAll('[data-mobile-submenu-open]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.new-mobile-nav__wrapper').forEach((root) => {
    new NewMobileNavigation(root);
  });
});
